import BaseModel from '@/model/BaseModel';
import UtilsNumber from '@/utils/UtilsNumber';

export default class ModelGraficoBarraPercentual extends BaseModel {
  constructor() {
    super();

    this.label = '';
    this.percentage = 0;
    this.quantity = 0;
    this.color = '#442D96';
    this.percentageColor = '#2A1C4F';
    this.bgColor = '#F7F7FD';
  }

  get percentageFormatted() {
    return UtilsNumber.toDecimals(this.percentage);
  }
}
